/**
 * @param {Object} configuracao Configuuração da notificação;
 * @param {string} configuracao.titulo Título da noticicação;
 * @param {string} configuracao.texto Mensagem em si "Sua duimp está pronta";
 * @param {html} configuracao.html Marcação html "<p>Clique <a href=''>aqui</a> para visualizar</p>"
 */
import { createApp } from "vue/dist/vue.cjs.prod.js";

function showNotificacao(configuracao){
  if (!configuracao || typeof configuracao !== 'object') {
    throw new Error('Configuração inválida');
  }
  criarElementoNotificacao(configuracao).then(renderNotificacao)
}

function criarElementoNotificacao(configuracao){
  const wrapperNotificacao  = document.querySelector('.wrapper-notificacao')
  const elementNotificacao = document.createElement('div'),
        elBoxNotificacao = document.createElement('div');
  elementNotificacao.classList.add('wrapper-notificacao');

  if(configuracao)
    elBoxNotificacao.data = configuracao;
  if(wrapperNotificacao == null){
    elementNotificacao.appendChild(elBoxNotificacao);
    document.body.appendChild(elementNotificacao);
  }
  return Promise.resolve({elBoxNotificacao, elementNotificacao});
}
const _Notificacao={
  app:null
};
function renderNotificacao(res){
  if (!res?.elBoxNotificacao || !res?.elementNotificacao) {
    throw new Error('Parâmetros inválidos para renderização');
  }
  const { elBoxNotificacao, elementNotificacao:wrapperNotificacao } = res
  wrapperNotificacao.classList.add('show-notificacao');
  if(!_Notificacao.app){
    _Notificacao.app = createApp({
      template:`
      <div class="inner-notificacao">
        <header>
          <h2>{{configuracao.titulo ? configuracao.titulo: 'Notificação' }}</h2>
          <button class="close" @click="fechaNotificacao">X</button>
        </header>
        <main>
          <span v-if="configuracao.texto">{{configuracao.texto}}</span>
          <span v-if="configuracao.html" v-html="configuracao.html"></span>
        </main>
      </div>
      `,
      data(){
        return{
          configuracao:{}
        }
      },
      methods:{
        fechaNotificacao(){
          wrapperNotificacao.classList.add('hide-notificacao')
          wrapperNotificacao.addEventListener("transitionend", function(ev) {
            wrapperNotificacao.remove();
            _Notificacao.app = null
          });
        }
      },
      created(){
        this.configuracao = elBoxNotificacao.data
      }
    }).mount(elBoxNotificacao);
  } else {
    _Notificacao.app.configuracao = elBoxNotificacao.data
  }

}
window.showNotificacao = showNotificacao
